import { useHotkeys } from 'react-hotkeys-hook';
import { SCORECARD_ELEMENT_SYMBOLS, ScorecardElementSymbol } from '../../../../Scorecard';
import { ElementRoutes } from '../../../components';
import { elementShortcutMap } from '../util';

export interface PresentationElementHotkeysProps {
  visibleElements: ScorecardElementSymbol[];
  routes: ElementRoutes;
  shortcutsEnabled: boolean;
  isEnterHeld: boolean;
  toggleElementVisibility: (element: ScorecardElementSymbol) => void;
  focusElementVisibility: (element: ScorecardElementSymbol) => void;
  navigateToElement: (element: ScorecardElementSymbol) => void;
}

interface PresentationElementHotkeyBindingProps extends Omit<PresentationElementHotkeysProps, 'visibleElements'> {
  element: ScorecardElementSymbol;
  isVisible: boolean;
}

function PresentationElementHotkeyBinding({
  element,
  isVisible,
  routes,
  shortcutsEnabled,
  isEnterHeld,
  toggleElementVisibility,
  focusElementVisibility,
  navigateToElement,
}: PresentationElementHotkeyBindingProps) {
  const shortcut = elementShortcutMap[element];
  const hasRoute = Boolean(routes[element]);

  useHotkeys(
    `${shortcut}`,
    () => {
      toggleElementVisibility(element);
    },
    { enabled: shortcutsEnabled && isVisible && !isEnterHeld }
  );

  useHotkeys(
    `shift+${shortcut}`,
    () => {
      focusElementVisibility(element);
    },
    { enabled: shortcutsEnabled && isVisible }
  );

  useHotkeys(
    `enter+${shortcut}`,
    () => {
      navigateToElement(element);
    },
    { enabled: shortcutsEnabled && isVisible && hasRoute }
  );

  return null;
}

export function PresentationElementHotkeys(props: PresentationElementHotkeysProps) {
  const { visibleElements } = props;

  return (
    <>
      {SCORECARD_ELEMENT_SYMBOLS.map((element) => (
        <PresentationElementHotkeyBinding
          key={element}
          {...props}
          element={element}
          isVisible={visibleElements.includes(element)}
        />
      ))}
    </>
  );
}
